//All colors with 3 shades of it
/*
300 : Lighter shade of the color
600:  Normal shade of the color
900:  Darker shade of the color
*/

export const green = { 300: '#5ce3b5', 600: '#40dfa8', 900: '#37b9a2' };
export const red = { 300: '#eb5971', 600: '#e9445f', 900: '#e62f4d' };
export const yellow = { 300: '#fdcc55', 600: '#e9445f', 900: '#e62f4d' };
export const blue = { 300: '#6cc0ed', 600: '#e9445f', 900: '#e62f4d' };
export const gray = { 300: '#dee6e9', 600: '#b8b8b8', 900: '#7c7c7c' };
